import {
  TriviaContextTypes,
  Question,
  responseValidateQuestion,
} from "../../interfaces";
import { TriviaState } from "./";

type TriviaActionType =
  | { type: TriviaContextTypes.SET_TRIVIA; payload: Question[] }
  | { type: TriviaContextTypes.SET_ACTIVE_QUESTION; payload: Question }
  | {
      type: TriviaContextTypes.SELECT_OPTION_QUESTION;
      payload: { question: Question; response: string };
    }
  | { type: TriviaContextTypes.SET_MISSING_RESPONSE; payload: boolean }
  | {
      type: TriviaContextTypes.SET_RESPONSE;
      payload: responseValidateQuestion[];
    }
  | { type: TriviaContextTypes.SET_LOAD_TRIVIA }
  | { type: TriviaContextTypes.SET_OPEN_TRIVIA }
  | { type: TriviaContextTypes.CLOSE_AND_CLEAR }
  | { type: TriviaContextTypes.RETRY_TRIVIA }
  | { type: TriviaContextTypes.SET_TRIVIA_ID; payload: number };

export const triviaReducer = (
  state: TriviaState,
  action: TriviaActionType
): TriviaState => {
  switch (action.type) {
    case TriviaContextTypes.SET_TRIVIA:
      return {
        ...state,
        questions: action.payload,
        isLoadTrivia: false,
      };
    case TriviaContextTypes.SET_ACTIVE_QUESTION:
      return {
        ...state,
        activeQuestion: action.payload,
      };
    case TriviaContextTypes.SELECT_OPTION_QUESTION:
      return {
        ...state,
        questions: state.questions.map((question) => {
          if (question.id === action.payload.question.id) {
            return {
              ...question,
              respuesta: action.payload.response,
            };
          }

          return question;
        }),
      };
    case TriviaContextTypes.SET_MISSING_RESPONSE:
      return {
        ...state,
        missingResponse: action.payload,
      };
    case TriviaContextTypes.SET_RESPONSE:
      return {
        ...state,
        result: action.payload,
      };
    case TriviaContextTypes.SET_LOAD_TRIVIA:
      return {
        ...state,
        isLoadTrivia: true,
      };
    case TriviaContextTypes.SET_OPEN_TRIVIA:
      return {
        ...state,
        isOpenTrivia: true,
      };
    case TriviaContextTypes.CLOSE_AND_CLEAR:
      return {
        ...state,
        questions: [],
        activeQuestion: null,
        missingResponse: false,
        isLoadTrivia: false,
        result: null,
        isOpenTrivia: false,
      };
    case TriviaContextTypes.SET_TRIVIA_ID:
      return {
        ...state,
        triviaId: action.payload,
      };
    case TriviaContextTypes.RETRY_TRIVIA:
      return {
        ...state,
        result: null,
        missingResponse: false,
        activeQuestion: state.questions[0] || null,
        questions: state.questions.map(q => ({
          ...q,
          respuesta: ''
        }))
      };
    default:
      return state;
  }
};
